import { createLogic } from 'redux-logic'
import handleErrors from '@app/helpers/handleErrors'
import { SYNC_ROOMS_LIST } from '@app/constants/rooms/rooms'
import Api from '@app/api/rooms'
import { API_REQUEST_CANCEL } from '@app/constants/apiRequest'
import { setRoomsList } from '@app/actions/rooms/rooms'
import { apiRequestSent, apiRequestDone, apiRequestFailed } from '../../actions/apiRequest'

const fetchRoomsList = createLogic({
  type: SYNC_ROOMS_LIST,
  cancelType: API_REQUEST_CANCEL,

  process(_, dispatch, done) {
    const { secrets: { accessToken: { token: AccessToken } } } = store.getState()
    dispatch(apiRequestSent(SYNC_ROOMS_LIST))
    Api.fetchRooms(AccessToken)
      .then((response) => {
        dispatch(setRoomsList(response.data))
        dispatch(apiRequestDone(SYNC_ROOMS_LIST))
      })
      .catch((error) => {
        if (error) {
          const currentError = handleErrors(error)
          dispatch(apiRequestFailed(currentError))
        } else {
          throw new Error('fetchRooms failed without error')
        }
      })
      .then(() => done())
  },
})

export default fetchRoomsList
